import { useState } from 'react';

const faqs = [
  {
    question: '虚空韩漫网的漫画都是正版吗？',
    answer: '是的，虚空韩漫网所有漫画内容均为正版授权。我们与多家韩国漫画平台达成合作，确保每部作品都获得合法授权，让读者可以放心阅读。',
  },
  {
    question: '如何开始阅读韩漫？',
    answer: '您可以通过首页的"立即开始阅读"按钮进入漫画列表，或通过分类导航选择您感兴趣的类型。点击任意漫画即可进入详情页，选择章节开始阅读。',
  },
  {
    question: '支持手机阅读吗？',
    answer: '完全支持。虚空韩漫网采用响应式设计，自动适配手机、平板和电脑屏幕。下拉式阅读方式在手机上体验尤为流畅，无需翻页即可连续阅读。',
  },
  {
    question: '漫画更新频率如何？',
    answer: '热门连载作品通常每周更新一话，具体更新频率取决于原作发行计划。您可以在网站首页的"最新更新"栏目查看最近更新的漫画。',
  },
  {
    question: '需要注册账号吗？',
    answer: '虚空韩漫网目前无需注册即可免费阅读所有漫画。我们致力于提供最便捷的阅读体验，打开网站即可畅读。',
  },
  {
    question: '如何联系我们？',
    answer: '您可以通过"关于我们"页面查看联系方式，或直接发送邮件至我们的官方邮箱。我们欢迎任何反馈和建议。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFaq = (idx: number) => {
    setOpenIndex(openIndex === idx ? null : idx);
  };

  return (
    <section className="w-full bg-background-100 py-12 md:py-16">
      <div className="max-w-[800px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading">
            常见问题
          </h2>
          <p className="text-sm text-foreground-500 mt-1">快速了解虚空韩漫网</p>
        </div>

        <div className="flex flex-col gap-3">
          {faqs.map((faq, idx) => (
            <div
              key={idx}
              className="bg-background-50 rounded-lg border border-background-200/60 overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
                onClick={() => toggleFaq(idx)}
              >
                <span className="text-sm font-semibold text-foreground-900 pr-4">{faq.question}</span>
                <div
                  className={`w-5 h-5 flex items-center justify-center shrink-0 transition-transform duration-200 ${
                    openIndex === idx ? 'rotate-180' : ''
                  }`}
                >
                  <i className="ri-arrow-down-s-line text-foreground-500"></i>
                </div>
              </button>
              {openIndex === idx && (
                <div className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                  {faq.answer}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}